module.exports = __webpack_public_path__ + "static/venti-selected-174e875e227d30b69f9967b9944fde77.png";